import { FC, ReactNode } from "react";
import { Grid } from "@payping/web-components";

interface Props {
  children?: ReactNode;
  className?: string;
}

export const SubLayout: FC<Props> = (props: Props) => {
  const { children, className } = props;
  const sizes = Grid.useBreakpoint();

  switch (true) {
    case sizes.xxl:
      return <div className={`tw-w-full tw-py-12 ${className}`}>{children}</div>;

    case sizes.xl:
      return <div className={`tw-w-full tw-py-12 ${className}`}>{children}</div>;

    case sizes.lg:
      return <div className={`tw-w-full tw-py-12 ${className}`}>{children}</div>;

    case sizes.md:
      return <div className={`tw-w-full tw-py-6 ${className}`}>{children}</div>;

    case sizes.sm:
      return <div className={`tw-w-full tw-py-6 ${className}`}>{children}</div>;

    case sizes.xs:
      return <div className={`tw-w-full tw-py-6 ${className}`}>{children}</div>;
    default:
      return <></>;
  }
};
